var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-switch',{attrs:{"dense":""},on:{"change":_vm.askPermissionAndSwitchSubscription},model:{value:(_vm.switchFlg),callback:function ($$v) {_vm.switchFlg=$$v},expression:"switchFlg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }